export const DONATIONSRECIEVEDBYDONOR_PAGE_LABELS = {
  heading: {
    en: "Donations by Donor",
    ta: "நன்கொடையாளர் மூலம் நன்கொடைகள்",
    si: "දායකයා විසින් කරන ලද පරිත්‍යාග",
  },
  download_report: {
    en: "Download Report",
    ta: "அறிக்கையைப் பதிவிறக்கவும்",
    si: "වර් තාව බාගත කරන්න",
  },
  donor_id: {
    en: "Donor ID",
    ta: "நன்கொடையாளர் ஐடி",
    si: "දායක හඳුනාගැනීමේ අංකය",
  },
  donor_name: {
    en: "Donor Name",
    ta: "நன்கொடையாளர் பெயர்",
    si: "දායක හඳුනාගැනීමේ අංකය",
  },
  public_id: {
    en: "Public ID",
    ta: "பொது ஐடி",
    si: "පොදු හඳුනාගැනීමේ අංකය",
  },
  donation_id: {
    en: "Donation ID",
    ta: "நன்கொடைகள் ஐடி",
    si: "පරිත්‍යාග හඳුනාගැනීමේ අංකය",
  },
  month: {
    en: "Month",
    ta: "மாதம்",
    si: "මාසය",
  },
  year: {
    en: "Year",
    ta: "ஆண்டு",
    si: "අවුරුදු",
  },
  date: {
    en: "Date",
    ta: "நாள்",
    si: "දිනය",
  },

  amount: {
    en: "Amount (LKR)",
    ta: "தொகை (LKR)",
    si: "මුදල (LKR)",
  },
  category: {
    en: "Category",
    ta: "வகை",
    si: "ප්‍රභේදය",
  },
};
